import { render } from "./AttachOld.vue?vue&type=template&id=2f4a321a"
import script from "./AttachOld.vue?vue&type=script&lang=js"
export * from "./AttachOld.vue?vue&type=script&lang=js"

import "./AttachOld.vue?vue&type=style&index=0&id=2f4a321a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__